import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { DirectoryService } from '../directory/directory.service';
import { UtilService } from '../util/util.service';

export const forceChangePasswordGuard: CanActivateFn = async (_route, state) => {
  const directoryService = inject(DirectoryService);
  const router = inject(Router);
  const utilService = inject(UtilService);

  if (!utilService.getJWT()) {
    return true;
  }

  let isToForceChangePassword: boolean;

  if (directoryService.hasToPasswordForceChange !== null && directoryService.hasToPasswordForceChange !== undefined) {
    isToForceChangePassword = directoryService.hasToPasswordForceChange;
  } else {
    try {
      isToForceChangePassword = await directoryService.passwordForceChange().toPromise();
    } catch (err) {
      // Token inválido ou expirado — permitir continuar
      return true;
    }
  }

  if (isToForceChangePassword) {
    router.navigate(['/password/forceChange'], { queryParams: { returnUrl: state.url } });
    return false;
  }

  return true;
};
